import { toNumber } from 'lodash';
import { useContext, useMemo, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { LeisureContext, Loader } from 'components';
import { isLink } from 'helpers';
import { useUser } from 'hooks';
import { appService } from 'services';

import 'assets/styles/components/products/ticketmaster-plan.scss';

const TicketMasterPlan = () => {
  const { t } = useTranslation();
  const planRef = useRef();
  const { leisure, emptySessions, addTicketmasterToCart, ticketmasterLoading } = useContext(LeisureContext);
  const { getValues } = useFormContext();
  const { currentUser } = useUser();

  const thumbnail = leisure?.prices?.images?.find((image) => image?.thumbnail?.includes('plan'))?.thumbnail;
  const visual = leisure?.prices?.images?.find((image) => image?.visual?.includes('plan'))?.visual;

  const showPlanCta = useMemo(() => {
    return getValues('leisureDate')?.plan && !emptySessions && (thumbnail || visual);
  }, [getValues('leisureDate'), emptySessions, thumbnail, visual]);

  const imgPlanSrc = useMemo(() => {
    return isLink(thumbnail) ? thumbnail : `${process.env.REACT_APP_CASTELIS_TUNNEL_URL}${thumbnail}`;
  }, [thumbnail]);

  const handleClick = () => {
    const apiBaseUrl = `${appService.getMiddlewareBaseUrl()}/ticketmaster`;
    const sessions = leisure.sessions.map((s) => ({ ...s, libelle: s.label }));

    window.jQuery(planRef.current).plan({
      autoOpen: true,
      lstSeances: sessions,
      modal: true,
      imgPlanSrc,
      codeLang: 'FR',
      idseance: toNumber(sessions[0].id),
      chargerListePlaces: `${apiBaseUrl}/load_seats?serialNumber=${currentUser?.serialNumber}`,
      chargerTarifSeance: `${apiBaseUrl}/load_session_prices?serialNumber=${currentUser?.serialNumber}`,
      validerSelection: (planValues) => addTicketmasterToCart(true, planValues)
    });
  };

  if (!showPlanCta) return null;

  return (
    <>
      <button type="button" className="btn mb-6" onClick={handleClick} disabled={ticketmasterLoading}>
        {ticketmasterLoading && <Loader loaderClass="w-4 h-4 text-white mr-2" />}
        {t('products:onPlanCta')}
      </button>

      <div ref={planRef} className="ticketmaster-plan" />
    </>
  );
};

export default TicketMasterPlan;
